import Quill from 'quill/core';

import Toolbar from 'quill/modules/toolbar';
import Snow from 'quill/themes/snow';

import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Underline from 'quill/formats/underline';
import Strike from 'quill/formats/strike';
import Header from 'quill/formats/header';
import CodeBlockContainer from 'quill/formats/code';
import Script from 'quill/formats/script';
import Blockquote from 'quill/formats/blockquote';
import List from 'quill/formats/list';
import { AlignAttribute, AlignClass, AlignStyle } from 'quill/formats/align';
import Link from 'quill/formats/link';
import Indent from 'quill/formats/indent';
import Image from 'quill/formats/image';
import ImageResize from '@taoqf/quill-image-resize-module/image-resize.min';

const Embed = Quill.import('blots/embed');
class TemplateMarker extends Embed {
  static create (value) {
    const node = super.create(value);
    node.setAttribute('class', `badge badge--${value.colour}`);
    // Set up the badge, and badge colour
    node.setAttribute('data-marker', value.marker);
    // The marker is the $ rel_table[id] reference
    node.setAttribute('data-title', value.title);
    //
    node.innerHTML = value.title;
    // The title is what the user sees in their editor
    return node;
  }

  static value (node) {
    return {
      marker: node.getAttribute('data-marker'),
      title: node.getAttribute('data-title'),
    };
  }
}
TemplateMarker.blotName = 'TemplateMarker';
TemplateMarker.tagName = 'span';

Quill.register({
  'modules/toolbar': Toolbar,
  'themes/snow': Snow,
  'formats/bold': Bold,
  'formats/italic': Italic,
  'formats/underline': Underline,
  'formats/strike': Strike,
  'formats/header': Header,
  'formats/code': CodeBlockContainer,
  'formats/script': Script,
  'formats/blockquote': Blockquote,
  'formats/list': List,
  'formats/align': AlignClass,
  'formats/align-attribute': AlignAttribute,
  'formats/align-style': AlignStyle,
  'formats/link': Link,
  'formats/indent': Indent,
  'formats/image': Image,
  'formats/TemplateMarker': TemplateMarker,
  'modules/imageResize': ImageResize,
});

export default Quill;
